/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TClaimGroup, TJoin, TNonEmptyArray, TPermissionGroup, TTenant } from "../../helpers/utils.graphql";
import { CommandResult_ClaimGroup, ListCommandResult_ClaimGroup } from "../../helpers/types.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TClaimGroup
  | TJoin<"tenant", TTenant>
  | TJoin<"permissionGroup", TPermissionGroup>
  | TJoin<"claims", TClaim>

type TClaimGroupByIdFunctions = { getByID: CommandResult_ClaimGroup }
export type TClaimGroupByIdQueries = { claimGroup: TClaimGroupByIdFunctions };
export const claimGroupById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimGroupById($id: Guid!) {
    claimGroup {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ClaimGroup")}
`;

type TClaimGroupAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_ClaimGroup }
export type TClaimGroupAllWithPaginationQueries = { claimGroup: TClaimGroupAllWithPaginationFunctions };
export const claimGroupAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimGroupAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    claimGroup {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ClaimGroup")}
`;

type TClaimGroupAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_ClaimGroup }
export type TClaimGroupAllWithSortedPaginationQueries = { claimGroup: TClaimGroupAllWithSortedPaginationFunctions };
export const claimGroupAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimGroupAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    claimGroup {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ClaimGroup")}
`;